<template lang="html">
  <div>

    

    <vs-card slot='header'>
      <vs-row slot='header'>
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="9">
          {{$t('TrackLogs')}}
            <feather-icon 
              icon="DownloadCloudIcon" 
              svgClasses="w-5 h-5 hover:text-danger stroke-current" 
              class="ml-5" 
              :title="$t('ExportList')"
              @click="activePrompt=true"
            />
          
        </vs-col>
        <vs-col v-if='false' vs-type="flex" vs-justify="center" vs-align="right" vs-w="3">
          Capture To Database 
          <vs-switch class='ml-1' @change='toggleCaptureToDB' v-model="storeToDB"></vs-switch>
        </vs-col>
      </vs-row>
    </vs-card>


    <template v-if='storeToDB'>
      <vs-table :data="logs">

        <vs-card slot='header'>
          <vs-row slot='header'>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-select
                @change='getAll()'
                :label="$t('track.action')"
                v-model="filter.action"
                >
                <vs-select-item :value="null" text="All" />
                <vs-select-item :key="index" :value="action" :text="action" v-for="action,index in actions" />
              </vs-select>
            </vs-col>

            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-select
                @change='getAll()'
                :label="$t('track.user')"
                v-model="filter.user_id"
                >
                <vs-select-item :value="null" text="All" />
                <vs-select-item :key="index" :value="user.id" :text="user.name" v-for="user,index in users" />
              </vs-select>
            </vs-col>

            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-select
                @change='getAll()'
                :label="$t('track.destination_user')"
                v-model="filter.destination_user_id"
                >
                <vs-select-item :value="null" text="All" />
                <vs-select-item :key="index" :value="user.id" :text="user.name" v-for="user,index in users" />
              </vs-select>
            </vs-col>

            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-select
                @change='getAll()'
                :label="$t('event.name')"
                v-model="filter.event_id"
                >
                <vs-select-item :value="null" text="All" />
                <vs-select-item :key="index" :value="event.id" :text="event.name" v-for="event,index in events" />
              </vs-select>
            </vs-col>
          </vs-row>  
        </vs-card> 
        
        <template slot="thead">
          <vs-th sort-key="action">{{ $t("track.action") }}</vs-th>
          <vs-th sort-key="user_id">{{ $t("track.user") }}</vs-th>
          <vs-th sort-key="destination_user_id">{{ $t("track.destination_user") }}</vs-th>
          <vs-th sort-key="event_id">{{ $t("event.name") }}</vs-th>
          <vs-th sort-key="event_id">{{ $t("Recording") }}</vs-th>
          <vs-th sort-key="event_voting_id">{{ $t("VotingName") }}</vs-th>
          <vs-th sort-key="agenda_id">{{ $t("AgendaName") }}</vs-th>
          <vs-th sort-key="action_at">{{ $t("track.action_at") }}</vs-th>
          <!-- <vs-th class="testing" :colspan="$store.getters.isRealAdmin?2:1" >{{ $t("Actions") }}</vs-th> -->
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in logs">

            <vs-td>
              {{ tr.action }}
            </vs-td>

            <vs-td>
              <router-link v-if='tr.user_id' :to="'/admin/users/viewhistory/' + tr.user_id">{{ tr.first_name + ' ' + tr.last_name }}</router-link>
              <template v-else>-</template>
            </vs-td>

            <vs-td>
              <router-link v-if='tr.d_user_id' :to="'/admin/users/viewhistory/' + tr.d_user_id">{{ tr.d_first_name + ' ' + tr.d_last_name }}</router-link>
              <template v-else>-</template>
            </vs-td>

            <vs-td>
              <router-link v-if='tr.event_id' :to="'/admin/event/pasteventdetails/' + tr.event_id">{{ tr.event_name  }}</router-link>
              <template v-else>-</template>
            </vs-td>
            <vs-td>
              <router-link v-if='tr.event_id' :to="'/admin/event/recordings/' + tr.event_id">{{ tr.event_name  }}</router-link>
              <template v-else>-</template>
            </vs-td>

            <vs-td>
              {{ tr.voting_name ? tr.voting_name : '-' }}
            </vs-td>

            <vs-td>
              {{ tr.agenda_name ? tr.agenda_name : '-' }}
            </vs-td>

            <vs-td>
              {{ tr.action_at | displayDate }}
            </vs-td>
          
          </vs-tr>
        </template>
      </vs-table>
      <a :download='exportFileName' ref='exportLink' style='display:none'>Export Excel</a>
      <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>


      <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancel="clearFields" @accept="exportToExcel" :accept-text="$t('Export')" @close="clearFields" :active.sync="activePrompt">
        <vs-input v-model="fileName" :placeholder="$t('EnterFileName') + '..'" class="w-full" />
        <v-select v-model="selectedFormat" :options="formats" class="my-4" />
        <!-- <div class="flex">
          <span class="mr-4">{{$t('CellAutoWidth')}}:</span>
          <vs-switch v-model="cellAutoWidth">{{$t('CellAutoWidth')}}</vs-switch>
        </div> -->
      </vs-prompt>
    </template>
    
    <template v-else>
      Enable to view all track logs captured into the Database
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { trackingLogs, trackingLogsExport, getTrackActions, toggleCaptureToDB } from '@/api/track-logs';
import { getUserLists } from '@/api/user';
import { getAllEvents } from '@/api/event';

function debounce(func, timeout = 4000){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export default {
  components: {
    vSelect
  },
	watch: {
		currentPage: function(page) {
			console.log('page-changed', page);
			this.getAll(page);
		}
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalItems/15);
		},
    exportFileName() {
      return `${this.fileName}.${this.selectedFormat}`;
    }
	},
  data: () => ({
    storeToDB: false,
    actions: [],
    users: [],
    events: [],
    filter: {
      action: null,
      user_id: null,
      destination_user_id: null,
      action_at: null
    },
    activePrompt: false,
    fileName: '',
		totalItems: 1,
		currentPage: 1,
    formats:['xlsx'],
    cellAutoWidth: true,
    selectedFormat: 'xlsx',
    logs: []
   }),
  beforeMount(){
    this.getAllActions();
    this.getAllUsers();
    this.getAllEvents();
    this.getAll()
  },
	mounted() { console.log(this.$refs) },
  methods: {
    handleSettingChange(e) {
      if(e.type=='input') {
        this.toggleCaptureToDB()
      }
    },
    async toggleCaptureToDB(event) {
      if(event.type!='input')
        return false;
      try{
        const response = await toggleCaptureToDB();
        if(response.status!=200 || response.data.status!= 'success')
          throw response.data.message;
        if(this.storeToDB)
          this.getAll();
      }catch(err) {
        console.error(err);
				this.$log.error('File : TrackLogs.vue | Function : toggleCaptureToDB() | Error :', err);
				// Error response
				this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					color: "danger",
					position: "top-center"
				});
      }
    },
    async getAllActions() {
      try{
        const response = await getTrackActions();
        if(response.status!=200 || response.data.status!= 'success')
          throw response.data.message;
        this.actions = response.data.data;
      }catch(err) {
        console.error(err);
				this.$log.error('File : TrackLogs.vue | Function : getAllActions() | Error :', err);
				// Error response
				this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					color: "danger",
					position: "top-center"
				});
      }
    },
    async getAllUsers() {
      try{
        const response = await getUserLists();
        if(response.status!=200 || response.data.status!= 'success')
          throw response.data.message;
        this.users = response.data.data.map(user => ({
          get name() {
            return `${this.first_name} ${this.last_name}`
          },
          first_name: user.first_name,
          last_name: user.last_name,
          id: user.id
        }));
        console.log('users', this.users);
      }catch(err) {
        console.error(err);
				this.$log.error('File : TrackLogs.vue | Function : getAllUsers() | Error :', err);
				// Error response
				this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					color: "danger",
					position: "top-center"
				});
      }
    },
    async getAllEvents() {
      try{
        const response = await getAllEvents();
        if(response.status!=200 || response.data.status!= 'success')
          throw response.data.message;
        this.events = response.data.data
        .map(event => ({
          name: event.event_name,
          id: event.id
        }));
      }catch(err) {
        console.error(err);
				this.$log.error('File : TrackLogs.vue | Function : getAllEvents() | Error :', err);
				// Error response
				this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					color: "danger",
					position: "top-center"
				});
      }
    },
    async getAll(page=1) {
      this.$vs.loading();
			try{ 
				const response = await trackingLogs({page, ...this.filter});
        if(response.status==200 && response.data.status== 'warn')
          this.storeToDB = false;
				else if(response.status==200 && response.data.status=='success') {
          this.logs = response.data.data;
          this.totalItems = response.data.meta.total_items;
          this.currentPage = response.data.meta.current_page;
          this.storeToDB = true;
        }else
					throw response.data.message;
				console.log(response); 				
			}catch(e){
				console.error(e);
				this.$log.error('File : TrackLogs.vue | Function : getAll() | Error :', e);
				// Error response
				this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					color: "danger",
					position: "top-center"
				});
			}
			this.$vs.loading.close();
    },
    async exportToExcel () {
			this.$vs.loading()
			try{
				const url = await trackingLogsExport({...this.filter});
				this.$refs.exportLink.setAttribute('href', url);
				this.$refs.exportLink.click();
			}catch(err){
				console.error(err);
				this.$log.error('File : TrackLogs.vue | Function : exportToExcel() | Error :', err);
				// Error response
				this.$vs.notify({
					title: this.$t('FailedToLoadData'),
					color: "danger",
					position: "top-center"
				});
			}
			this.$vs.loading.close();
			return;
      import('@/utils/Export2Excel').then(excel => {
        const list = this.events
        const data = this.formatJson(this.headerVal, list);
        const header = this.headerTitle.map(t => this.$t(t));
        excel.export_json_to_excel({
          header: header,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
}
</script>

<style lang="scss">
.nexteventheader_div {
  border-radius: 0 !important;
}
.vx-card__title p{
  font-weight: 600 !important;
  font-size: 1.0rem !important;
  padding-bottom: 10px;
}
.vx-card__header{
  padding: 1.2rem 1.2rem 0 !important;
}
.run_btn{
  padding: 0.5rem 1.1rem !important;
  font-size: 12px;
}
.testing{
  text-align: center;
}
.testing .vs-table-text{
  display: unset;
}
.testertd {
  width: 15%;
  text-align: center;
}
.run_btn_action{
  width: 13%;
}
.actioniconmanage{
  margin-top: 1px;
}
</style>